export { default as Loading } from "./loading";



// WEBPACK FOOTER //
// ./src/components/loading/index.ts